var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotate-wrapper"},[_c('div',{staticClass:"rotate-wrapper_content"},[_c('div',{staticClass:"rotate-wrapper_circle"},[_c('div',{staticClass:"rotate-wrapper_phone"})]),_c('span',{staticClass:"rotate-wrapper_text"},[_vm._v("Please rotate your device")])])])
}]

export { render, staticRenderFns }